'use strict';

export const HEALTH_CHECK_STATUS = Object.freeze({
  GREEN: 0,
  YELLOW: 1,
  RED: 2,
  GREY: 3,
});
